/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const CLIENT_PROMOTIONS_PER_PAGE = 4;

export const useGetClientPromotions = (page = 1, queryParams) => {
  return useQuery({
    queryKey: queryKeys.clientPromotions.list(page),
    queryFn: () =>
      fetcher({
        method: "GET",
        url: "/public/promotions/purchased",
        params: {
          include: "print_link",
          page,
          on_page: CLIENT_PROMOTIONS_PER_PAGE,
          order_field: "can_be_used",
          order_direction: "desc",
        },
      }),
    ...queryParams,
  });
};
